module.exports = __webpack_public_path__ + "img/product3.e137b484.png";